import { SET_STATS } from "../mutation-types";

export default {
  [SET_STATS]: ({ commit }, serviceId) => {
    commit(SET_STATS, serviceId);
  }
};
